<div class="modal-header">
	<h2 class="mt-2" >
		<svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34">
			<g fill="none" fill-rule="evenodd">
				<g fill="#0CC5D1">
					<path
						d="M32.786 0C33.456 0 34 .544 34 1.214v13.358c0 .322-.128.63-.356.858L15.43 33.644c-.474.475-1.243.475-1.717 0L.356 20.287c-.475-.474-.475-1.243 0-1.717L18.57.356c.228-.228.536-.356.858-.356zM31.57 2.429h-11.64l-17 17 11.64 11.64 17-17V2.429zM25.5 4.857c2.012 0 3.643 1.631 3.643 3.643 0 2.012-1.631 3.643-3.643 3.643-2.012 0-3.643-1.631-3.643-3.643 0-2.012 1.631-3.643 3.643-3.643zm0 2.429c-.67 0-1.214.543-1.214 1.214 0 .67.543 1.214 1.214 1.214.67 0 1.214-.543 1.214-1.214 0-.67-.543-1.214-1.214-1.214z"
						transform="translate(-704 -231) translate(440 199) translate(214 20) translate(0 12) translate(50)" />
				</g>
			</g>
		</svg>
		<!-- <ng-container i18n="@@ts.minor_fee_adjustment_coming">Minor Fee Adjustment Coming June 1st</ng-container> -->
		<ng-container i18n="@@ts.minor_fee_adjustment_notification_header">Minor Fee Adjustment</ng-container>
	</h2>
</div>
<div class="modal-body">
	<!-- <p i18n="@@ts.minor_fee_adjustment_coming_description">To continue enhancing our services and streamline your experience, our processing fees will be 2.5% (for all local cards) starting June 1st. This consolidated fee covers all bank processing and Teem platform (service & admin) fees. By proceeding, you agree to these updated terms.</p> -->
	<p i18n="@@ts.minor_fee_adjustment_notification_description">Please be informed that as of 22nd September 2025, the new online payments processing fees of 2.5% + VAT are being implemented.</p>
	
	<form class="add-store-type" [formGroup]="addTapForm" (ngSubmit)="onSubmit()" #tapForm="ngForm">
		<div class="">
			<div class="radio-group">
				<div class="d-flex align-items-center m-2">
					<input type="radio" id="store-product" name="is_agreement_accept" class="custom-radio" value="1" formControlName="is_agreement_accept" >
					<label class="m-0" for="store-product" i18n="@@ts.i_agree"> I Agree</label>
				</div>
				<div class="d-flex align-items-center m-2">
					<input type="radio" id="store-service" name="is_agreement_accept" class="custom-radio" value="2" formControlName="is_agreement_accept" >
					<label class="m-0" for="store-service" i18n="@@ts.i_dont_agree"> I don’t agree (stop online payments) </label>
				</div>
			</div>
		</div>
		<!-- <div class="signup_main">
			<div class="checkbox_cont">
				<div class="custom-checkbox">
					<input type="radio" name="is_agreement_accept" class="select-item" formControlName="is_agreement_accept">
					<svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
						<g clip-path="url(#clip0_3435_5711)">
							<path d="M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z" fill="#646464" />
						</g>
						<defs>
							<clipPath id="clip0_3435_5711">
								<rect width="24" height="24" fill="white" />
							</clipPath>
						</defs>
					</svg>
					<svg class="checked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
						<g clip-path="url(#clip0_3488_11753)">
							<path d="M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.11 21 21 20.1 21 19V5C21 3.9 20.11 3 19 3ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" fill="#EB1461" />
						</g>
						<defs>
							<clipPath id="clip0_3488_11753">
								<rect width="24" height="24" fill="white" />
							</clipPath>
						</defs>
					</svg>
				</div>
				<span for="allow-instant-order" i18n="@@ts.i_agree"> I Agree </span>
			</div>
		</div> -->
	</form>
	

</div>
<div class="modal-footer">
	<button type="button" class="tu-btn pink" i18n="@@button.submit" form="ngForm" (click)="tapForm.ngSubmit.emit()">Submit</button>
</div>
